import React from "react";
import { Modal } from "antd";
import { Icon } from "Components";

interface ExitCampaignModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ExitCampaignModal: React.FC<ExitCampaignModalProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={495}
      bodyStyle={{ padding: 0 }}
    >
      <div className="pm-modal-container">
        <div className="pm-modal-header">
          <div className="pm-modal-header-left">
            <span className="pm-modal-title">Exit campaign setup?</span>
          </div>
          <button
            className="pm-modal-close-icon"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon type="campaignModalClose" />
          </button>
        </div>

        <div className="pm-modal-body">
          <p>If you exit now, all progress in this campaign setup will be lost.</p>
          <br />
          <p>This campaign has not been started and no emails will be sent.</p>
        </div>

        <div className="pm-modal-footer">
          <div className="pm-modal-footer-actions">
            <button className="pm-btn-plain" onClick={onClose}>
              Continue setup
            </button>
            <button className="pm-btn-primary" onClick={onConfirm}>
              Exit and discard setup
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExitCampaignModal;